export default {
    namespaced: true,
    state: {
        quant: 1,
        annexation: 0
    },
    mutations: {
        setQuant(state, payload) {
            state.quant = payload
        },
        setPrice (state, payload) {
            state.annexation = payload
        }
    },
    getters: {

    },
    actions: {},
    modules: {

    }
}